import { combineReducers } from 'redux';
import * as types from './constants';
import * as wsTypes from '~/redux/middleware/socket/constants';
import * as AuthTypes from '@components/auth/constants';

const initialState = {
    sidebar: {
        isOpened: localStorage.getItem('sidebarState') === 'true',
        isHover: false,
        subMenu: {
            users: localStorage.getItem('usersMenuState') === 'true',
            catalog: localStorage.getItem('catalogMenuState') === 'true',
            warehouse: localStorage.getItem('warehouseMenuState') === 'true',
            settings: localStorage.getItem('settingsMenuState') === 'true',
            orders: localStorage.getItem('ordersMenuState') === 'true',
            scansheets: localStorage.getItem('scansheetsMenuState') === 'true',
            marketing: localStorage.getItem('marketingMenuState') === 'true',
            analytics: localStorage.getItem('analyticsMenuState') === 'true',
        }
    },
    preloader: {
        show: false
    },
    socket: {
        connected: false
    },
    modals: [],
    socketModal: {
        open: false,
        data: {}
    },
    counters: {
        orders: [],
        ordersChangeStatus: false,
        chats: 0
    },
    notifications: [],
};

const getOrdersChangeStatus = (prevState, newState) => {
    let prevCountItem = prevState.orders.filter(order => order?.status?.action === 'new')?.[0];
    if (!!prevCountItem) {
        let newCountItem = newState.orders.filter(order => order?.status?.action === 'new')?.[0];
        if (!!newCountItem) {
            return prevState.ordersChangeStatus || prevCountItem.total !== newCountItem.total;
        }
    }
    return true;
}

export default combineReducers({
    sidebar(state = initialState.sidebar, action) {
        switch (action.type) {
            case types.LAYOUT_SIDEBAR_OPEN:
                return { ...state, isOpened: true };
            case types.LAYOUT_SIDEBAR_CLOSE:
                return { ...state, isOpened: false };
            case types.TOGGLE_SUB_MENU:
                return {...state, subMenu: {...state.subMenu, [action.name]: !state.subMenu[action.name]}}
            case types.LAYOUT_MOUSE_OVER_SIDEBAR:
                return { ...state, isHover: true };
            case types.LAYOUT_MOUSE_LEAVE_SIDEBAR:
                return { ...state, isHover: false };
            case types.LAYOUT_MOUSE_OVER_OPENED_SIDEBAR:
                return { ...state, isHover: true };
            case types.LAYOUT_MOUSE_LEAVE_OPENED_SIDEBAR:
                return { ...state, isHover: false };
            default:
                return state;
        }
    },
    preloader(state = initialState.preloader, action) {
        switch (action.type) {
            case types.LAYOUT_PRELOADER_OPEN:
                return { ...state, show: true };
            case types.LAYOUT_PRELOADER_CLOSE:
                return { ...state, show: false };
            default:
                return state;
        }
    },
    socket(state = initialState.socket, action) {
        switch (action.type) {
            case wsTypes.SOCKET_CONNECTED:
                return { ...state, connected: true };
            case wsTypes.SOCKET_CONNECTING:
            case wsTypes.SOCKET_DISCONNECTED:
                return { ...state, connected: false };
            default:
                return state;
        }
    },
    modals(state = initialState.modals, action) {
        switch (action.type) {
            case AuthTypes.USER_CONTEXT_SUCCESS:
                return [ ...state, ...(action.modals || []) ];
            case types.MODAL_WINDOW_CLOSE:
                const {data: {id}} = action;
                const modals = state.filter(modal => modal.id !== id);
                return [ ...modals ];
            default:
                return state;
        }
    },
    socketModal(state = initialState.socketModal, action) {
        switch (action.type) {
            case types.SOCKET_MODAL_SHOW:
                return { open: true, data: action.data };
            case types.SOCKET_MODAL_CLOSE:
                return { open: false, data: {} };
            default:
                return state;
        }
    },
    counters(state = initialState.counters, action) {
        switch (action.type) {
            case types.UPDATE_COUNTERS:
                const {counters} = action.data;
                return {...counters, ordersChangeStatus: getOrdersChangeStatus(state, counters)};
            case types.UPDATE_CHAT_COUNTERS:
                state.chats = action.data.counters.chats;
                return {...state};
            case types.LAYOUT_MOUSE_OVER_SIDEBAR:
                return { ...state, ordersChangeStatus: false };
            case types.LAYOUT_SIDEBAR_OPEN:
                return { ...state, ordersChangeStatus: false };
            case types.LAYOUT_MOUSE_OVER_OPENED_SIDEBAR:
                return { ...state, ordersChangeStatus: false };
            default:
                return state;
        }
    },
    notifications(state = initialState.notifications, action) {
        switch (action.type) {
            case AuthTypes.LOGIN_ATTEMPT_SUCCESS:
            case AuthTypes.USER_CONTEXT_SUCCESS:
            case types.UPDATE_NOTIFICATIONS_LIST:
                return [ ...action?.notifications || [] ];
            default:
                return state;
        }
    },
});
